<template>
  <svg id="Capa_1" enable-background="new 0 0 512 512" :width="width" :height="height" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
    <g :fill="color">
      <path d="m0 421h512v91h-512z" />
      <path d="m226 30-30 15-30-15-30 15-30-15v181h120z" />
      <path
        d="m465.242 151h-104.242v-30h60v-121h-150v121h60v30h-75v90h-180v-90h-28.242l-30.998 240h478.48zm-314.242 210h-30v-30h30zm0-60h-30v-30h30zm60 60h-30v-30h30zm0-60h-30v-30h30zm60 60h-30v-30h30zm0-60h-30v-30h30zm60 60h-30v-30h30zm0-60h-30v-30h30zm60 60h-30v-30h30zm0-60h-30v-30h30zm15-60h-120v-30h120z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: String },
    height: { type: String },
    color: { type: String }
  }
}
</script>
